exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-study__lightswan .case-study__photo-background{background-color:#f7f3ea}.case-study__lightswan .case-study__photo{margin-top:100px}.case-study__lightswan .case-study__color-block .case-study__mini-title{opacity:1;text-align:center;margin-top:.5em}.case-study__lightswan .case-study__full-screenshot__bg{background-color:#f7f3ea;min-height:2500px;max-height:2500px}.case-study__lightswan .case-study__screen-circle{background-color:#f7f3ea}.case-study__lightswan .case-study__mobile-screen__img{margin-top:100px}.case-study__lightswan .case-study__home{font-size:30px;width:100%;margin-top:10em}.case-study__lightswan .case-study__perspective-mockup{display:block;margin-top:10em}.case-study__lightswan .case-study__article-mobile{margin-top:10em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-55757bf4!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/CaseStudy/Lightswan.vue
// module id = 120
// module chunks = 0